const initialState = {
  name: '',
  language: 'th',
  phone: '',
  phoneRef: '',
  id: '',
  session: 10,
  email: '',
  token: '',
  phoneSelected: undefined,
  count_wrong: 0,
  lineid: '',
  consent: 'blank',
  emails: [],
};

const user = (state = initialState, action) => {
  switch (action.type) {
  case 'SETNAME':
    return {
      ...state,
      name: action.name,
    };

  case 'SETLANGUAGE':
    return {
      ...state,
      language: action.language,
    };

  case 'SETID':
    return {
      ...state,
      id: action.id,
    };

  case 'SETEMAIL':
    return {
      ...state,
      email: action.email,
    };

  case 'SETSESSION':
    return {
      ...state,
      session: action.session,
    };

    //count, expireDate, email, otpREF, OTP
  case 'SETPROFILE':
    return {
      ...state,
      count: action.count,
      expireDate: action.expireDate,
      email: action.email,
      otpREF: action.otpREF,
      OTP: action.OTP,
    };

  case 'SET_CAPTCHA_STATUS':
    return {
      ...state,
      captcha_status: action.captcha_status,
    };

  case 'SET_CAPTCHA':
    return {
      ...state,
      captcha: action.captcha,
      captcha_ref: action.captcha_ref,
    };

  case 'SET_OTP':
    return {
      ...state,
      OTP: action.OTP,
      otpREF: action.otpREF,
    };

  case 'SET_EMAILS':
    return {
      ...state,
      emails: action.emails,
    };

  default:
    return state;
  }
};

export default user;
